import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import analytics from '@/store/modules/analytics'
import apps from '@/store/modules/apps'
import appNotifications from '@/store/modules/appNotifications'
import attendees from '@/store/modules/attendees'
import auth from '@/store/modules/auth'
import businesses from '@/store/modules/businesses'
import calls from '@/store/modules/calls'
import campaigns from '@/store/modules/campaigns'
import companies from '@/store/modules/companies'
import conversations from '@/store/modules/conversations'
import dataTables from '@/store/modules/dataTables'
import events from '@/store/modules/events'
import forms from '@/store/modules/forms'
import graphicAspect from '@/store/modules/graphicAspect'
import journey from '@/store/modules/journey'
import listsPersons from '@/store/modules/listsPersons'
import notifications from '@/store/modules/notifications'
import orders from '@/store/modules/orders'
import payments from '@/store/modules/payments'
import providers from '@/store/modules/providers'
import realEstate from '@/store/modules/realEstate'
import roles from '@/store/modules/roles'
import sequences from '@/store/modules/sequences'
import sideBar from '@/store/modules/sideBar'
import speech from '@/store/modules/speech'
import triggers from '@/store/modules/triggers'
import users from '@/store/modules/users'
import usersTasks from '@/store/modules/usersTasks'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    analytics,
    apps,
    appNotifications,
    attendees,
    auth,
    businesses,
    calls,
    campaigns,
    companies,
    conversations,
    dataTables,
    events,
    forms,
    graphicAspect,
    journey,
    listsPersons,
    notifications,
    orders,
    payments,
    providers,
    realEstate,
    roles,
    sequences,
    sideBar,
    speech,
    triggers,
    users,
    usersTasks
  },
  plugins: [
    createPersistedState({ paths: ['apps', 'auth', 'companies', 'dataTables'] })
  ]
})
